<template>
  <img
    :src="vecyLogoUrl"
    alt="VeCy"
    :class="sizeClass"
    class="inline-block shrink-0 object-contain object-left"
    loading="lazy"
    decoding="async"
  />
</template>

<script setup>
import { computed } from 'vue';
import vecyLogoUrl from '@/assets/images/vecy-logo.png';

const props = defineProps({
  size: {
    type: String,
    default: 'sm',
  },
});

const sizeClass = computed(() => {
  if (props.size === 'md') return 'h-5 w-auto max-w-[54px]';
  if (props.size === 'xs') return 'h-4 w-auto max-w-[44px]';
  return 'h-[18px] w-auto max-w-[48px]';
});
</script>
